import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 
    "editNameAr", "editNameEn", "editPrice", 
    "editWithImage", "editCountable", "editBlocked", "editAllBlocked", "editForAll",
    "editId" 
  ]

  edit(event) {
    event.preventDefault()
    const data = event.params
    
    this.editNameArTarget.value = data.nameAr
    this.editNameEnTarget.value = data.nameEn
    this.editPriceTarget.value = data.price
    
    // Handle booleans
    this.editWithImageTarget.value = data.isWithPicture
    this.editCountableTarget.value = data.isCountable
    this.editBlockedTarget.value = data.isBlocked
    this.editAllBlockedTarget.value = data.isAllBlocked
    this.editForAllTarget.value = data.isForAll
    
    this.editIdTarget.value = data.id
    
    $('#edit_procedure_detail').modal('show')
  }
}
